var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"employee_page",style:({'background-image': 'url('+_vm.previewUrl+')'})},[_c('van-image',{staticClass:"auto",attrs:{"width":"300","height":"auto","src":_vm.QRCodeUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }